import 'jquery-circle-progress';
document.addEventListener('DOMContentLoaded', function () {
    function animateElements() {
        $('.animated-status-circle__item').each(function () {
            const elementPos = $(this).offset().top;
            const topOfWindow = $(window).scrollTop();
            const percent = $(this).find('.animated-status-circle__item-status').attr('data-percent');
            const percentage = (percent * 0.773) / 100;
            const animate = $(this).data('animate');
            const size = 157;
            if (elementPos < topOfWindow + $(window).height() - 30 && !animate) {
                $(this).data('animate', true);
                $(this)
                    .find('.animated-status-circle__item-status')
                    .circleProgress({
                        startAngle: -4,
                        value: percentage,
                        size: size,
                        thickness: 10,
                        emptyFill: '#F2F3F6',
                        fill: {
                            color: '#D71920',
                        },
                    })
                    .on('circle-animation-progress', function (event, progress, stepValue) {
                        $(this)
                            .find('.animated-status-circle__item-number')
                            .text(Number(((stepValue * 100) / 0.773).toFixed(2)).toLocaleString('pt-br', { minimumFractionDigits: 2 }) + '%');
                    })
                    .stop();
            }
        });
    }

    $(window).on('scroll', animateElements);
});
